module.exports = __webpack_public_path__ + "img/n_bg.e024db9d.jpg";